import React, { useState, useMemo } from 'react'
import Loading from './Loading'
import useData from '../hooks/useData'
import Input from './Input'
import Button from './Button'
import Flag from './Flag'
import useInputValue from '../hooks/useInputValue'
import { LOCALE } from '../constants/'
import { post } from '../modules/fetch'
import history from '../modules/history'

const CreateArticleTranslation = function CreateArticleTranslation(props) {
    const id = props.id || (props.match && props.match.params && props.match.params.id) || false
    let { data: article } = useData('article/' + id)
    const siteArray = useData('site')
    const siteData = useData('site/' + article?.site_id, [article?.site_id])
    const site_array = useMemo(() => {
        return siteArray.data?.filter((s) => s.locale !== siteData.data?.locale) || []
    }, [siteArray.data, siteData.data])

    // console.log({ siteData })
    // console.log({ article })

    const siteInput = useInputValue()
    console.log({ siteInput })
    const [isCreatingTranslation, setIsCreatingTranslation] = useState(false)

    const createArticleTranslation = () => {
        if (!siteInput.value) {
            console.warn('Please select a target site first')
            return
        }
        console.log('calling api /article/translation with', { article_id: id, target_site_id: siteInput.value })
        setIsCreatingTranslation(true)
        post('article/translation', { article_id: id, target_site_id: siteInput.value }).then((r) => history.push('/article/edit/' + r.id))
    }

    return (
        <React.Fragment>
            {((!article || !siteArray.data || !siteData.data) && <Loading text="Fetching article data" />) || (
                <>
                    <h2 className="mb-0">Translate &laquo;{article.title}&raquo;</h2>
                    <div>from {siteData.data.label}</div>
                    <div className="mt-3">
                        <label htmlFor="destination_website">
                            <strong>Choose destination website:</strong>
                        </label>
                        <Input
                            id="destination_website"
                            type="select"
                            options={Object.keys(LOCALE)
                                .reduce((acc, locale) => {
                                    const candidate = acc.find((l) => l.locale === locale) || {
                                        locale,
                                        site_array: site_array.filter((s) => s.locale === locale),
                                    }
                                    candidate.site_array.length && acc.push(candidate)
                                    return acc
                                }, [])
                                .reduce((acc, l) => {
                                    acc = [...acc, ...l.site_array]
                                    return acc
                                }, [])
                                .map(
                                    (s) => ({
                                        ...s,
                                        label: (
                                            <>
                                                <Flag locale={s.locale} className="mr-2" />
                                                {s.label}
                                            </>
                                        ),
                                    })
                                    // site_array.map((s) => ({
                                    //     ...s,
                                    //     label: (
                                    //         <>
                                    //             <Flag locale={s.locale} className="mr-2" />
                                    //             {s.label}
                                    //         </>
                                    //     ),
                                    // })
                                )}
                            {...siteInput}
                            label="Choose destination website"
                        />
                        <Button className="btn-primary mt-2" disabled={!siteInput.value} onClick={createArticleTranslation} isLoading={isCreatingTranslation}>
                            Create article
                        </Button>
                    </div>
                </>
            )}
        </React.Fragment>
    )
}

export default CreateArticleTranslation
